import * as angular from 'angular';
import { ITooltip, ITooltipService } from '../services/tooltipService';

angular.module('app').directive('tagTooltip', tagTooltip);

function tagTooltip(
	$compile: angular.ICompileService,
	$http: angular.IHttpService,
	$q: angular.IQService,
	$templateCache: angular.ITemplateCacheService,
	$transitions,
	tooltipService: ITooltipService
) {
	return {
		restrict: 'A',
		scope: false,
		link(scope, elem, attrs) {
			const templateFetchAborter = $q.defer();
			let unwatch;
			const offset = 0;
			let tooltipScope;

			function createScope() {
				const newScope = scope.$new(true);
				unwatch = scope.$watch(attrs.tagTooltip, asset => {
					newScope.asset = asset;
				});

				return newScope;
			}

			function initializeTooltip(cancellationToken) {
				cancellationToken.then(() => {
					templateFetchAborter.resolve();
				});

				return $http
					.get<any>('views/templates/tagTooltip.html', {
						timeout: templateFetchAborter.promise,
						cache: $templateCache,
					})
					.then(response => {
						const template = response.data;
						const create = $compile(template);
						tooltipScope = createScope();
						return create(tooltipScope);
					});
			}

			function destroyTooltip() {
				if (unwatch) {
					unwatch();
				}
				if (tooltipScope) {
					tooltipScope.$destroy();
				}
			}

			let tooltip: ITooltip | null = null;

			function createTooltip() {
				const container = elem.closest('[tooltip-container]');

				tooltip = tooltipService.createTooltip(elem, initializeTooltip, {
					container,
					tooltipHideDelay: 0,
					onDestroy: destroyTooltip,
					tooltipOffset: offset,
				});
				$transitions.onStart({}, tooltip.destroy);
				container.on('scroll', tooltip.destroy);

				scope.$on('$destroy', () => {
					templateFetchAborter.resolve();

					if (tooltip) {
						container.off('scroll', tooltip.beginHide);
						tooltip.destroy();
					}
				});
			}

			scope.showTooltip = function (e) {
				if (scope.asset && !e.buttons) {
					if (!tooltip) {
						createTooltip();
					}

					tooltip!.beginShow();
				}
			};

			scope.hideTooltip = function () {
				if (tooltip) {
					tooltip.beginHide();
				}
			};

			elem.context.addEventListener('mouseover', scope.showTooltip);
			elem.context.addEventListener('mouseup', scope.hideTooltip);
			elem.context.addEventListener('mousedown', scope.hideTooltip);
			elem.context.addEventListener('mouseout', scope.hideTooltip);

			scope.$on('$destroy', () => {
				elem.context.removeEventListener('mouseover', scope.showTooltip);
				elem.context.removeEventListener('mouseup', scope.hideTooltip);
				elem.context.removeEventListener('mousedown', scope.hideTooltip);
				elem.context.removeEventListener('mouseout', scope.hideTooltip);
			});
		},
	};
}
